import styled from 'styled-components'

export const ScratchContainer = styled.div`
  width: 100%;
  height: calc(100vh - var(--footer-height) - var(--header-height));
  min-height: 500px;
  background-color: var(--container-color-alt);
`;

export const ScratchContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Scratchpad = styled.div`
  width: 550px;
  height: 550px;
  cursor: grabbing;  
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* Adicione esta linha */

  .ScratchCard__Result {
    width: 100%;
    height: 100%;

    .scratch__tryagain {
      background-image: url("../../img/tryagain450.png");
      background-size: cover;
      width: 550px;
      height: 550px;
      border: 2px solid var(--text-color-light);
    }
    .scratch__winner {
      background-image: url("../../img/winner450.png");
      background-size: cover;
      width: 550px;
      height: 550px;
      border: 2px solid var(--text-color-light);
    }
  }
`;

export const MediaScratchpad = styled.div`
  width: 375px;
  height: 375px;

  .ScratchCard__Container {
    width: 100% !important;
    height: 100% !important;

    .scratch__content {
      height: auto;
    }
  }

  .ScratchCard__Canvas {
    width: 375px !important;
    height: 375px !important;
  }

  .scratch__tryagain {
    width: 375px !important;
    height: 375px !important;
  }

  .scratch__winner {
    width: 375px !important;
    height: 375px !important;
  }
`;

